import { render, staticRenderFns } from "./center2.vue?vue&type=template&id=3fc7f394&"
import script from "./center2.vue?vue&type=script&lang=js&"
export * from "./center2.vue?vue&type=script&lang=js&"
import style0 from "./center2.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports